export const city_images = 
{
    Westhampton: [
    "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Westhampton/IMG-2738.JPG",
    "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Westhampton/IMG-3058.JPG",
    "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Westhampton/IMG-2074.jpg",
    "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Westhampton/IMG-3105.JPG",
    "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Westhampton/IMG_1777.JPG",
    "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Westhampton/IMG_2010.JPG",
    "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Westhampton/IMG-3178.JPG",
    "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Westhampton/IMG-3244.jpg",
    "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Westhampton/IMG-5345.JPG",
    "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Westhampton/IMG_2081.jpeg",
    "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Westhampton/IMG_2091.jpeg",
    "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Westhampton/IMG_2133.jpeg",
    "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Westhampton/IMG_2153.jpeg", 
    "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Westhampton/IMG-2115.jpg",
    "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Westhampton/64695887040--AD45FE07-3C4B-4387-8271-61269F6B1219.jpg",
    "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Westhampton/IMG-0522.JPG",
    "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Westhampton/IMG-1949.jpg",
    "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Westhampton/IMG-2684.PNG",
    "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Westhampton/IMG_1111.JPG",
    "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Westhampton/IMG_1393.PNG",
    "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Westhampton/IMG_1683.JPG",
    "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Westhampton/IMG_2093.JPG",
    ], 
    Bear: [], 
    Roanoke: [
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Roanoke/IMG_2204.JPG",
        
    ],
    Dallas: [
        // "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Dallas/IMG-0079.jpeg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Dallas/IMG-0081.jpeg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Dallas/IMG-0235.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Dallas/IMG-0271.jpeg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Dallas/IMG-9960.JPG",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Dallas/IMG-9854.jpeg",
    ], 
    LasCruces: [
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Las+Cruces/IMG-0671.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Las+Cruces/IMG-0675.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Las+Cruces/IMG-0524.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Las+Cruces/IMG-0579.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Las+Cruces/IMG-0584.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Las+Cruces/IMG-0622.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Las+Cruces/IMG-0690.jpg",
    ],
    Memphis: [
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Memphis/IMG_9573.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Memphis/IMG_9594.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Memphis/IMG_9608.jpg",
    ], 
    Nashville: [
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Nashville/IMG_2205.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Nashville/IMG-2211.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Nashville/IMG-9431.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Nashville/IMG-9442.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Nashville/IMG-9506.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Nashville/IMG-9319.jpg",
    ],
    Texarkana: [
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Texarkana/IMG-2256.JPG",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Texarkana/IMG-9684.JPG",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Texarkana/IMG-9773.JPG",
    ], 
    Topeka: [],
    Tucson: [
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Tucson/IMG-7499.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Tucson/IMG-0142.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Tucson/IMG-0236.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Tucson/IMG-1339.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Tucson/IMG-3700.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Tucson/IMG-7531.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Tucson/IMG-9798.jpg",
    ], 
    Odessa: [],
    LasVegas: [
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Las+Vegas/IMG-5242.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Las+Vegas/IMG-5481.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Las+Vegas/IMG-5491.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Las+Vegas/IMG-5507.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Las+Vegas/IMG-5615.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Las+Vegas/IMG-5623.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Las+Vegas/IMG-5633.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Las+Vegas/IMG-5686.jpg",
    ],
    Zion: [
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Zion/IMG-4523.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Zion/IMG-4637.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Zion/IMG-4657.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Zion/IMG-4659.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Zion/IMG-4675.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Zion/IMG-4711.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Zion/IMG-4749.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Zion/IMG-4785.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Zion/IMG-4850.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Zion/IMG-4856.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Zion/IMG-4858.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Zion/IMG-4870.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Zion/IMG-4878.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Zion/IMG-4896.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Zion/IMG-4925.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Zion/IMG-4939.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Zion/IMG-5055.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Zion/IMG-5062.jpg"
     ]
     ,
    NewRochelle: [
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/New Rochelle/IMG-0328.JPG",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/New Rochelle/IMG-0372.JPG",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/New Rochelle/IMG-0405.JPG",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/New Rochelle/IMG-1012.JPG",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/New Rochelle/IMG-1104.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/New Rochelle/IMG-1177.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/New Rochelle/IMG-1339.PNG",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/New Rochelle/IMG-1407.PNG",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/New Rochelle/IMG-1455.JPG",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/New Rochelle/IMG-1460.JPG",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/New Rochelle/IMG-1465.JPG",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/New Rochelle/IMG-1470.JPG",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/New Rochelle/IMG-1942.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/New Rochelle/IMG-1950.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/New Rochelle/IMG-1959.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/New Rochelle/IMG-1976.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/New Rochelle/IMG-4159.jpeg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/New Rochelle/IMG-7591.JPG"
     ],
     Georgia: [
        "Georgia/IMG_0612.JPG",
        "Georgia/IMG_0652.JPG",
        "Georgia/IMG_0655.JPG",
        "Georgia/IMG_0662.JPG",
        "Georgia/IMG_0719.JPG",
        "Georgia/IMG_0000.JPG",
        "Georgia/IMG_0727.JPG",
        "Georgia/IMG_0757.JPG",
        "Georgia/IMG_0767.JPEG",
        "Georgia/IMG_5058.JPG",
        "Georgia/IMG_5080.JPG",
        "Georgia/IMG_5090.JPG",
        "Georgia/IMG_9539.JPG"
     ], 
     Lewisburg: [
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Lewisburg/IMG-0511.JPG",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Lewisburg/IMG-1182.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Lewisburg/IMG-1218.jpg",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Lewisburg/IMG_0207.JPG",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Lewisburg/IMG_0213.JPG",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Lewisburg/IMG_0347.JPG",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Lewisburg/IMG_0413.JPG",
        "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/Lewisburg/IMG_0466.JPG"
     ],
}
